import { BiteSizeOption, type } from "./types";

type BiteSizeQuestion = {
    question:string,
    options: BiteSizeOption[]
}

// A) A Linked List
// B) A Binary Search Tree (BST)
// C) A Hash Table
// D) A Stack 
export const BITESIZEDQuestions : {[key:string]: BiteSizeQuestion} = {
  [type.BEHAVIORAL]: {
    question: "Tell me about yourself. First pick the best framework to use below.",
    options:[
        {
            label: "Past - Present - Future", 
            value: "I choose Present: Your current role and main responsibilities. Past: Relevant experience that led you here. Future: Why you're interested in a particular role.",
            info:"Present: Your current role and main responsibilities. Past: Relevant experience that led you here. Future: Why you're interested in a particular role.",
            response: "Great, now using this framework, give me your 45 second elevator pitch.",
        },
        {
            label: "Personal Details - Hobbies - Casual Experience", 
            value: "I choose Personal Details: Where you're from, birthday. Hobbies: Non-work interests. Casual Experience: Unrelated past jobs.",
            info:"Personal Details: Where you're from, birthday. Hobbies: Non-work interests. Casual Experience: Unrelated past jobs.",
            response: "This framework is less effective because it shifts the focus away from your qualifications and lacks relevance to the role, leaving the interviewer without a clear picture of your professional capabilities or how you'd add value to the company. Stick to frameworks that highlight your skills, experience, and motivation for the role instead. Try selecting another framework.",
        }
        // {
        //     label: "Skills-Driven Approach", 
        //     value: "I choose Skills-Driven Approach: Focus on key technical and soft skills that make you a strong fit for the role.",
        //     info: "Focus on key technical and soft skills that make you a strong fit for the role.",
        //     response: "This framework is best if you know the role requires specific technical or soft skills and want to emphasize them directly. With this is mind, you can select another framework better suited for you, or carry on with this framework and give me your 45 second elevator pitch.",
        // },
        // {
        //     label: "Passion - Journey - Purpose", 
        //     value: "I choose Passion: What drives you in your work. Purpose: Why this role aligns with your goals. Journey: Key experiences that shaped your path.",
        //     info: "Passion: What drives you in your work. Purpose: Why this role aligns with your goals. Journey: Key experiences that shaped your path.",
        //     response: "Great, now using this framework, give me your 45 second elevator pitch.",
        // }
    ]
},

  [type.TECHNICAL]: {question: "You're designing an app where users search for their favorite foods, and you want to make sure the search results show up super fast! Which data structure would be the tastiest choice? 🍕🔍",
    options:[
        {
            label: "Linked List", 
            value: "Linked List",
            response: "A Linked List is like a restaurant line—you must check each person one by one to find someone. Slow for searching! Try to pick a different option.",
        },
        {
            label: "Binary Search Tree (BST)", 
            value: "Binary Search Tree (BST)",
            response: "Okay! Can you explain why you chose a Binary Search Tree?",
        },
        {
            label: "Hash Table", 
            value: "Hash Table",
            response: "Okay! Can you explain why you chose a hash table?",
        },
        {
            label: "Stack", 
            value: "Stack",
            response: "Stacks are great for things like undoing actions, but not for looking up food names. Try to pick a different option.",
        }
    ]}
}